import { showOverlay, hideOverlay, setupGlobalOverlayLogic } from './ui-utils.js';
import { initAllPageComponents } from './page-ui.js';

export function configureNaja(naja) {

    /* 1. CONFIRM DIALOGY (data-confirm="Opravdu?") */
    naja.uiHandler.addEventListener('interaction', (e) => {
        const el = e.detail.element;
        const question = el?.dataset.confirm;
        if (question && !window.confirm(question)) {
            e.preventDefault();
            e.stopImmediatePropagation();
        }
    });

    /* 2. DOUBLE SUBMIT PROTECTION (Ochrana proti dvojkliku) */
    naja.uiHandler.addEventListener('interaction', (e) => {
        const el = e.detail.element;
        if (el.dataset.najaLocked) {
            e.preventDefault();
            e.stopImmediatePropagation();
            return;
        }

        el.dataset.najaLocked = 'true';
        el.classList.add('pointer-events-none', 'opacity-70');

        const unlock = () => {
            delete el.dataset.najaLocked;
            el.classList.remove('pointer-events-none', 'opacity-70');
            naja.removeEventListener('complete', unlock);
            naja.removeEventListener('error', unlock);
        };

        naja.addEventListener('complete', unlock);
        naja.addEventListener('error', unlock);
    });

    /* 3. PROPOJENÍ S OVERLAYEM */
    naja.addEventListener('start', (e) => {
        if (e.detail.element?.hasAttribute('data-overlay')) {
            showOverlay('AJAX Start');
        }
    });

    naja.addEventListener('complete', hideOverlay);
    naja.addEventListener('error', hideOverlay);

    /* 4. REINIT PO AJAXU */
    naja.addEventListener('complete', () => {
        setTimeout(() => {
            initAllPageComponents(document);
        }, 50);
    });

    /* 5. AUTOMATICKÉ NAČÍTÁNÍ SKELETONŮ (Při prvním načtení stránky) */
    naja.registerExtension({
        initialize(naja) {
            naja.addEventListener('init', () => {
                const elements = document.querySelectorAll('[data-naja-render-on-init]');
                elements.forEach(el => {
                    const url = el.getAttribute('data-href');
                    if (url) {
                        naja.makeRequest('GET', url, null, { history: false });
                    }
                });
            });
        }
    });

    /* 6. RUČNÍ SPOUŠTĚNÍ SKELETONU (Při kliknutí na měsíc/rok/filtr) */
    naja.uiHandler.addEventListener('interaction', (e) => {
        const el = e.detail.element;
        if (el?.hasAttribute('data-show-skeleton')) {
            const snippet = document.getElementById('snippet--scheduleSnippet');
            if (snippet) {
                snippet.innerHTML = `
                    <div class="animate-pulse space-y-4 w-full">
                        <div class="h-12 bg-gray-200 rounded-md w-full mb-6"></div>
                        <div class="border border-gray-200 rounded-md overflow-hidden">
                            <div class="h-10 bg-gray-200 w-full mb-1"></div>
                            <div class="space-y-2 p-2">
                                <div class="h-8 bg-gray-100 rounded w-full"></div>
                                <div class="h-8 bg-gray-100 rounded w-full"></div>
                                <div class="h-8 bg-gray-100 rounded w-full"></div>
                                <div class="h-8 bg-gray-100 rounded w-full"></div>
                            </div>
                        </div>
                    </div>`;
            }
        }
    });

    /* 7. AKTIVACE GLOBÁLNÍ LOGIKY PRO KLASICKÉ ODKAZY */
    setupGlobalOverlayLogic();

    console.log('✅ Naja nastavena (Events, Overlay, Reinit, Skeleton-AutoLoad).');
}